import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiPaginatorComponent } from './fi-paginator.component';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
    imports: [CommonModule, FiAppTextSharedModule, MatButtonModule, MatIconModule],
    declarations: [FiPaginatorComponent],
    exports: [FiPaginatorComponent],
})
export class FiPaginatorModule {}
